module.exports = __webpack_public_path__ + "img/down_orange_arrow.dc413b47.svg";